import * as types from '../actions/actionTypes.js';
import initialState from "./initialState.js";

export function branchReducer(
  state = initialState.branch, action
) {
  switch (action.type) {
    case types.FETCH_BRANCH_SUCCESS:
        return action.branch;
    default:
        return state;
  }
}

